import * as React  from 'react';
import '../../inCss/Error.css';
import '../../inCss/Card.css';
import { Link } from 'react-router-dom';

export interface AccountProps {
    errorTitle: string;
    errorMessage: string;
    errorStatus: string;
    clickEvt: () => void;
    reLogin: () => void;
}
export const AccountErrorCard: React.StatelessComponent<AccountProps> = (props: AccountProps) => {

    return (
        <div className="card">
            <div className="card-body">
                    <p className="card-text">
                        <div className="alert alert-danger" role="alert">
                        <span id="errorMessage"><img src="./img/errwarn.png"/></span>&nbsp;&nbsp;{props.errorMessage}
                        </div>
                    </p>
                <p className="card-text body-text" id="inshead">
                    To continue you can do one of the following:
                </p>
                <ol className="ol-text">
                    <li>
                            Log into&nbsp;
                        <a href="https://www.my.telstra.com.au/myaccount/home" id="telstra" target="_blank">
                            Telstra My Account
                        </a>&nbsp;
                        and link your service to your Telstra ID,&nbsp;
                        <a href="https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs#how-to-link-telstra-id" target="_blank">view instructions</a>
                    </li>
                    <li>
                    <Link to="#" id="telstralog" onClick={() => props.reLogin()}>Login with a Telstra ID</Link> 
                    &nbsp;
                associated with this service
                    </li>
                    <li>
                    Remove the current profile and sign up to a new Telstra Mobile Broadband Plan,&nbsp;
                    <a href="https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs#delete-esim-profile" target="_blank">
                    view instructions
                    </a>
                    <p>
                        <a 
                            href="https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:invalidtdi" 
                            target="_blank" 
                            id="faqlink"
                        >
                            View FAQ's for more information
                        </a>
                    </p>
                    </li>
                </ol>                 
            </div>
        </div>
    );
};

export default AccountErrorCard;



// WEBPACK FOOTER //
// ./src/components/cards/AccountErrorCard.tsx